export function initMobileMenuToggle() {
  document.addEventListener('click', function (event) {
    const menu = event.target.closest('.po-manu-list');
    if (!menu) return;

    menu.classList.toggle('po-manu-list_open');
  });
}
